import React from 'react';
import { Button } from '@/components/ui/button';

function formatDateTime(value) {
  if (!value) return '—';
  const d = new Date(value);
  if (isNaN(d)) return value;
  return d.toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' });
}

function ReviewRow({ label, value }) {
  return (
    <div className="flex flex-col gap-1 border-b pb-3">
      <span className="text-xs font-semibold uppercase tracking-wide text-gray-500">{label}</span>
      <span className="text-sm text-gray-800">{value || '—'}</span>
    </div>
  );
}

export default function StepReview({ formik, onBack, onSaveDraft, onPublish, submitting, isEditing, questionCount = 0 }) {
  const { name, description, starts_at, ends_at } = formik.values;

  return (
    <div className="page page--wrap">
      <div className="page__col">
        <div className="page__content mb-12 animate-fade-in">
          <div className="new-questions__header">
            <h2 className="new-questions__title">Revisão</h2>
            <p className="text-sm text-gray-500">Confira os dados antes de salvar.</p>
          </div>

          <div className="mt-6 flex flex-col gap-4">
            <ReviewRow
              label="Nome"
              value={name}
            />
            <ReviewRow
              label="Descrição"
              value={description}
            />
            <ReviewRow
              label="Início das inscrições"
              value={formatDateTime(starts_at)}
            />
            <ReviewRow
              label="Fim das inscrições"
              value={formatDateTime(ends_at)}
            />
            <ReviewRow
              label="Perguntas adicionais"
              value={`${questionCount} pergunta${questionCount === 1 ? '' : 's'}`}
            />
          </div>
        </div>

        <div className="flex flex-col gap-3">
          {!isEditing && (
            <Button
              type="button"
              variant="default"
              size="md"
              wide
              disabled={submitting}
              onClick={onPublish}
            >
              {submitting ? 'Salvando...' : 'Publicar agora'}
            </Button>
          )}

          <Button
            type="button"
            variant={isEditing ? 'default' : 'outline'}
            size="md"
            wide
            disabled={submitting}
            onClick={onSaveDraft}
          >
            {submitting ? 'Salvando...' : isEditing ? 'Salvar alterações' : 'Salvar como rascunho'}
          </Button>

          <Button
            type="button"
            variant="ghost"
            size="md"
            wide
            onClick={onBack}
            disabled={submitting}
          >
            Voltar
          </Button>
        </div>
      </div>
    </div>
  );
}
